<template>
  <div
    class="d-flex flex-column br-12 overflow-hidden"
    :class="[
      'sdui-alert-' + variant,
      {
        'gray-300-bg text-secondary': variant === 'info',
        'white-bg px-4 py-3 text-gray-300': variant === 'info-note',
        'secondary-bg text-gray-300': variant === 'info-inverted',
        'warning-bg text-secondary': variant === 'warning',
        'danger-bg text-secondary': variant === 'danger',
        'success-bg text-secondary': variant === 'success',
      },
    ]"
  >
    <div class="d-flex">
      <div :class="[`icon-area-${variant}`, iconAlignment]" class="d-flex justify-content-center">
        <sdui-icon class="icon fz-big" :class="[icon, iconClass]" />
      </div>
      <b-alert :show="show"
               :variant="variant"
               class="mb-0"
               :class="alertClass"
      >
        <slot name="title" />

        <slot name="content">
          <h5 class="text-black font-weight-light m-0">{{ content }}</h5>
        </slot>

        <div
          v-if="!displayActionAsFullRow && ($hasSlotContent($slots['left-action']) || $hasSlotContent($slots['right-action']))"
          class="d-flex"
          :class="actionClass"
        >
          <slot name="left-action" />
          <slot name="right-action" />
        </div>
      </b-alert>
    </div>

    <div v-if="displayActionAsFullRow"
         class="d-flex"
         :class="actionClass"
    >
      <slot name="left-action" />
      <slot name="right-action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SduiAlert',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true,
    },

    variant: {
      type: String,
      default: 'info',
      validator: function (value) {
        return ['info', 'info-inverted', 'warning', 'danger', 'success', 'info-note'].includes(value)
      },
    },

    content: {
      type: String,
      default: null,
    },

    customIcon: {
      type: String,
      default: null,
    },

    alignIcon: {
      type: String,
      default: 'middle',
      validator: function (value) {
        return ['top', 'middle', 'bottom'].includes(value)
      },
    },

    alertClass: {
      type: String,
      default: '',
    },

    iconClass: {
      type: String,
      default: '',
    },

    displayActionAsFullRow: {
      type: Boolean,
      default: false,
    },

    actionClass: {
      type: [String, Array],
      default: 'justify-content-between',
    },
  },

  data: () => ({
    iconVariants: {
      info: { class: 'icon-info' },
      'info-inverted': { class: 'icon-info' },
      warning: { class: 'icon-message-warning' },
      danger: { class: 'icon-message-warning' },
      success: { class: 'icon-check' },
    },

    iconAlignments: {
      top: { class: 'align-items-start' },
      middle: { class: 'align-items-center' },
      bottom: { class: 'align-items-end' },
    },
  }),

  computed: {
    icon() {
      return this.customIcon || this.iconVariants[this.variant]?.class
    },

    iconAlignment() {
      return this.iconAlignments[this.alignIcon]?.class
    },
  },
}
</script>

<style scoped lang="scss">
[class*='sdui-alert-'] {
  [class*='icon-area-'] {
    min-width: 48px;
  }

  [class*='alert-'] {
    width: 100%;
    min-width: 48px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.sdui-alert-info {
  border: 1px solid $color-gray-100;
}
.sdui-alert-info-note {
  box-shadow: 0 4px 12px rgba($color-black-rgb, 0.1);
}
.sdui-alert-info-inverted {
  border: 1px solid $color-gray-100;
}
.sdui-alert-success {
  border: 1px solid $color-success;
}
.sdui-alert-danger {
  border: 1px solid $color-danger;
}
.sdui-alert-warning {
  border: 1px solid $color-warning;
}
</style>
